import { Settings } from 'lucide-react';
import { useBreadcrumbs } from '@/client/hooks/use-breadcrumbs';
import { FlagSwitch, FlagSwitches } from './WalletPanels';

const GROUPS: Array<{ title: string; flags: FlagSwitch[] }> = [
  {
    title: 'Payment gateway',
    flags: [
      {
        name: 'billing.paystack.live',
        label: 'Paystack live account (go-live switch)',
        master: 'billing',
        confirmOn:
          'Turn on the LIVE Paystack account? Real customers will be charged real money from now on. Testers stay on the test account.',
      },
    ],
  },
  {
    title: 'Billing',
    flags: [
      { name: 'billing', label: 'Billing (master switch)' },
      { name: 'billing.subscription.checkout', label: 'Subscription checkout, card update and plan change', master: 'billing' },
      { name: 'payment', label: 'Payment endpoints' },
      { name: 'cart', label: 'Cart and checkout' },
      { name: 'voucher', label: 'Vouchers' },
    ],
  },
  {
    title: 'Wallet',
    flags: [
      { name: 'wallet', label: 'Wallet (master switch)' },
      { name: 'wallet.fund', label: 'Add funds', master: 'wallet' },
      { name: 'wallet.pay', label: 'Pay invoices from wallet', master: 'wallet' },
      { name: 'wallet.withdraw', label: 'Withdraw', master: 'wallet' },
    ],
  },
  {
    title: 'Payouts',
    flags: [{ name: 'store.payout', label: 'Store payouts' }],
  },
];

const BillingSettingsPage = () => {
  useBreadcrumbs([{ label: 'Billing & Payments', href: '/admin/payments/overview' }, { label: 'Settings' }]);
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="mx-auto max-w-screen-lg space-y-6">
        <div>
          <div className="mb-1 flex items-center gap-2.5">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-600">
              <Settings className="h-4 w-4 text-white" />
            </div>
            <h1 className="text-2xl font-black text-gray-900">Billing settings</h1>
          </div>
          <p className="text-sm text-gray-500">
            What customers can do with money on the platform. Every switch here takes effect
            without a deploy.
          </p>
        </div>
        {GROUPS.map((g) => (
          <FlagSwitches key={g.title} title={g.title} flags={g.flags} />
        ))}
      </div>
    </div>
  );
};

export default BillingSettingsPage;
